/**
 * Ranking — Em breve placeholder (Story DEMO.7).
 * Original implementation preserved in git history.
 */
import { AppLayout } from "@/components/layout/AppLayout";
import { ComingSoon } from "@/components/shared/ComingSoon";
import { usePageTitle } from "@/hooks/usePageTitle";

export default function Ranking() {
  usePageTitle("Ranking");
  return (
    <AppLayout>
      <ComingSoon
        title="Ranking"
        description="Seu posicionamento na comunidade"
      />
    </AppLayout>
  );
}
